module.exports = __webpack_public_path__ + "media/images/icons/icon_etc-1c023b51aa708c6b607dea1dd4953708.png";